module.exports = __webpack_public_path__ + "app-static/img/p_08.6e44df3c.jpg";